import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { FiLogOut } from 'react-icons/fi';
import { RemoveScroll } from 'react-remove-scroll';
import { Box, Flex, ClickableBox, Button, EthAddress } from './ui';
import { openseaApiKey } from 'utils/config';

interface WalletInfoProps {
  address: string;
  onLogout: () => void;
}

interface OpenSeaUserInfo {
  user?: {
    username?: string;
  };
  address: string;
  profile_img_url: string;
}

const Slider = styled.div<any>`
  position: absolute;
  right: ${props => (props.open ? 0 : '-300px')};
  top: 80px;
  transition: 0.2s linear right;
  padding: 24px;
  width: 280px;
  height: 100vh;
  z-index: 101;
  background-color: #333;
  box-shadow: 0 8px 5px 5px rgba(0, 0, 0, 0.3);
`;

const WalletInfo = ({ address, onLogout }: WalletInfoProps) => {
  const [userInfo, setUserInfo] = useState<OpenSeaUserInfo | null>(null);
  const [open, setOpen] = useState(false);

  // TODO: test this throwing error to make sure no issue
  const fetchOpenseaUser = useCallback(
    async (address: string) => {
      const response = await axios.get(`https://api.opensea.io/api/v1/account/${address}`, {
        headers: {
          'X-API-KEY': openseaApiKey,
        },
      });
      if (response.status === 200) {
        let { data }: any = response.data;
        setUserInfo(data);
      }
    },
    [setUserInfo]
  );

  // fetch user data from opensea
  useEffect(() => {
    if (address) {
      fetchOpenseaUser(address);
    }
  }, [address, fetchOpenseaUser]);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const ref = useDetectClickOutside({
    onTriggered: () => setOpen(false),
  });

  return (
    <div ref={ref}>
      <ClickableBox
        border="2px solid white"
        borderRadius="50%"
        overflow="hidden"
        width="40px"
        height="40px"
        onClick={toggleOpen}
        backgroundImage={userInfo?.profile_img_url ? `url(${userInfo?.profile_img_url})` : 'none'}
        backgroundSize="cover"
      />

      <Slider open={open}>
        {open && (
          <RemoveScroll>
            <Box textAlign="center">
              {userInfo && userInfo.user ? (
                <Box mb={2} fontWeight="bold">
                  {userInfo.user.username}
                </Box>
              ) : null}
              <Box my={3}>
                <EthAddress address={address} />
              </Box>
              <Link to="/my-collection">
                <Button width="100%" bg="black" color="white" mb={2}>
                  My EB Collection
                </Button>
              </Link>
              <Button width="100%" bg="black" color="white" onClick={onLogout}>
                <Flex>
                  <Box mr={2}>Logout</Box>
                  <FiLogOut color="white" />
                </Flex>
              </Button>
            </Box>
          </RemoveScroll>
        )}
      </Slider>
    </div>
  );
};

export default WalletInfo;
